import { Button, Tooltip } from 'antd';
import { useDispatch } from 'umi';
import React from 'react';
import { CheckAccess } from '@/utils/access';
import PERMISSIONS from '@/constants/permissions';
import { processSingleServiceRequest } from '@/components/Kanban/ServiceRequests/Calendar/utils';
import { RiCalendarScheduleLine } from '@/components/Icons/CustomReactIcons';
import { F } from '@/utils/intl';


const RescheduleServiceRequestAction = ({
                                          serviceRequest,
                                          lead,
                                          children,
                                          setLoading = (loading: boolean) => {
                                          },
                                          onOpenReschedule,
                                          onSuccess,
                                          buttonSize = 'small',
                                          showActionText = false,
                                          ...buttonProps
                                        }) => {

  const dispatch = useDispatch();

  lead = lead || serviceRequest.lead;
  const handleReschedule = () => {
    if (onOpenReschedule) onOpenReschedule();
    dispatch({
      type: 'serviceRequest/toggleCreateServiceRequestDrawer',
      payload: {
        event: {
          ...serviceRequest,
          lead,
        },
        then: onSuccess,
      },
    });
  };

  if (!processSingleServiceRequest(serviceRequest).isEditable) return null;

  return <CheckAccess access={[PERMISSIONS.ServiceRequests.RESCHEDULE, PERMISSIONS.BUSINESS_PARTNER]}>
    <Tooltip title={showActionText ? undefined : <F id={'pages.serviceRequest.reschedule'} defaultMessage={'Reschedule'}/>}>
      <Button data-testid="service-request-reschedule-btn" onClick={handleReschedule} size={buttonSize} shape={"round"} color={"gold"} variant={"filled"} {...buttonProps} icon={<RiCalendarScheduleLine style={{width: 16}}/>}>
        {showActionText && <F id={'pages.serviceRequest.reschedule'} defaultMessage={'Reschedule'}/>}
      </Button>
    </Tooltip>
  </CheckAccess>;
};

export default RescheduleServiceRequestAction;
